import React from 'react';
import { Col, Row } from 'antd';

import type { ToolsToolTip } from './types';
import { ToolCardItem } from './ToolCardItem';
import type { ErgonomicTools } from '@/hooks';

import { FixedWidthCardItem, FixedWidthCardList } from './styles';

const TWO_PER_LINE_SPAN = 12;
const FULL_LINE_SPAN = 24;
const ROW_GUTTER: [number, number] = [24, 16];

export interface ToolCardsContentProps {
	fileId: string;
	tools: ErgonomicTools[];
	isActive: (tool: ErgonomicTools) => boolean;
	toolsTooltip?: ToolsToolTip;
	fixedCardWidth?: boolean;
}

export function ToolCardsContent({
	fileId,
	tools,
	isActive,
	toolsTooltip,
	fixedCardWidth = false
}: Readonly<ToolCardsContentProps>): JSX.Element {
	function renderItem(tool: ErgonomicTools): JSX.Element {
		return <ToolCardItem fileId={fileId} tool={tool} isActive={isActive(tool)} toolsTooltip={toolsTooltip} />;
	}

	if (fixedCardWidth) {
		return (
			<FixedWidthCardList>
				{tools.map((tool) => (
					<FixedWidthCardItem key={tool.id}>{renderItem(tool)}</FixedWidthCardItem>
				))}
			</FixedWidthCardList>
		);
	}

	const cardSpan = tools.length > 1 ? TWO_PER_LINE_SPAN : FULL_LINE_SPAN;

	return (
		<Row gutter={ROW_GUTTER}>
			{tools.map((tool) => (
				<Col key={tool.id} span={cardSpan}>
					{renderItem(tool)}
				</Col>
			))}
		</Row>
	);
}
